import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/JujaProject";

const Juja = () => {
  const projectId = "PRJ00090";
  const title = "Juja Project";

  const mapConfig = {
    minZoom: 13,
    zoom: 14,
    bounds: [
      [40.66, -74.086],
      [40.64, -74.043],
    ],
    // No overlays active in original file
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      // viewProjectLink="https://www.optiven.co.ke/plots-in-ngong/achievers-paradise-ngong-kimuka-phase2/"
      // fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSeq-h_ydPVfvofXJj1FNvHBRtB_f7soDmVfM2Bvquy4H7L6VA/viewform"
    />
  );
};

export default Juja;
